<template>
  <vue-dropzone 
		id="dzone" 
		ref="dzone"
		class="mt-4"
		:options="options" 
		:useCustomSlot=true
		v-on:vdropzone-error="dropzoneError"
		v-on:vdropzone-file-added="dropzoneAdded"
		v-on:vdropzone-removed-file="dropzoneRemove"
>
	<b-icon icon="cloud-arrow-up-fill" font-scale="3"></b-icon>
	<p class="mb-0"><span class="text-primary font-weight-500">Upload files</span> or Drop files here</p>
</vue-dropzone>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone';

export default {
	name: "upload-files",
	components: {
		vueDropzone: vue2Dropzone,
	},
	data(){
		return {
			files:[],
			options: {	
				url: '#',
				addRemoveLinks: true,
				maxFiles: 5,
				autoProcessQueue: false,
				acceptedFiles: [
					'application/pdf',
					'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
					'application/vnd.openxmlformats-officedocument.presentationml.presentation',
					'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
					'application/msword',
					'application/vnd.ms-powerpoint',
					'application/vnd.ms-excel',
					'application/rtf',
					'application/octet-stream',
					'text/csv',
					'text/xml',
					'text/plain',
					'image/webp',
					'image/png',
					'image/jpg',
					'image/jpeg',
					'application/zip',
					'application/x-rar-compressed'
				].join(','),
			},
		}
	},
	methods:{
		dropzoneError(file, error, xhr){
			// console.log(file)
			console.error(error)
		},
		dropzoneAdded(file){
			this.files.push(file);
			this.$emit('addFiles', this.files)
			this.$refs.dzone.removeAllFiles();
		},
		dropzoneRemove(file, error, xhr){
			this.files = this.files.filter(item => {
				// console.log(item)
				return item.upload.uuid != file.upload.uuid;
			});
			this.$emit('removeFiles', this.files)
		},
	}
};
</script>
